import { render, staticRenderFns } from "./DetalleEvaluacionProductividad.vue?vue&type=template&id=13d5743e"
import script from "./DetalleEvaluacionProductividad.vue?vue&type=script&lang=js"
export * from "./DetalleEvaluacionProductividad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports